<template>
  <div class="bv-example-row">
    <div class="item-container">
      <div class="col-item" v-for="(item, index) in sourceData" :key="index">
        <div v-if="item.deviceType == '1' && (item.deviceCode != '' && item.deviceCode != null)" style="cursor: pointer" @click="navigateToPhoto1(item)">
          <b-img :src="item.lastPhoto" style="width: 350px; height: 200px; cursor: pointer" v-if="item.lastPhoto && item.deviceCode"></b-img>
          <b-img src="../assets/暂无图片.png" style="width: 350px; height: 200px" v-else></b-img>
        </div>
        <div v-else-if="item.deviceType == '0' && (item.deviceCode != '' && item.deviceCode != null)" style="cursor: pointer" @click="navigateToPhoto1(item)">
          <b-img :src="getImageSrc(item)" style="width: 350px; height: 200px; cursor: pointer" v-if="item.lastPhoto && item.deviceCode"></b-img>
          <b-img src="../assets/暂无图片.png" style="width: 350px; height: 200px" v-else></b-img>
        </div>
        <div v-else>
          <b-img :src="getImageSrc(item)" style="width: 350px; height: 200px" v-if="item.lastPhoto && item.deviceCode"></b-img>
          <b-img src="../assets/暂无图片.png" style="width: 350px; height: 200px" v-else></b-img>
        </div>
        <div class="stationName"><span>道口名称： {{ item.stationName }}</span></div>
        <div>位<span class="space"></span>置：{{ item.lineName }}-{{ item.workSection }}</div>
        <div v-if="item.cs=='1'" style="color: #f00">
          照片更新时间：{{ (item.updateTime == undefined || item.updateTime == '') ? "暂无" : item.updateTime }}
        </div>
        <div v-else>
          照片更新时间：{{ item.updateTime }}
        </div>
      </div>
    </div>

    <!-- 移动设备iframe直播（完全保留原有逻辑） -->
    <b-modal no-close-on-backdrop no-close-on-esc scrollable id="modal-img" size="xl" hide-footer title="直播" ref="modalYD" @hidden="handleModalYDClose">
      <b-row>
        <b-col>
          <iframe :src="YDUrl" style="width: 100%; height: 625px;" ref="iframeYD"
                  allow="autoplay *; microphone *; fullscreen *" allowfullscreen="true" allowtransparency="true"
                  allowusermedia="true" frameBorder="no"></iframe>
        </b-col>
        <b-col cols="4">
          <p><strong>观测地点 : {{ clickItem.lineName || "" }} {{ clickItem.stationName || "" }}</strong></p>
          <p><strong>电话卡号 : {{ clickItem.phoneId || "暂无" }}</strong></p>
          <p><strong>里程( k ) : {{ clickItem.distance || "暂无" }}</strong></p>
          <p><strong>当前接收时间 : {{ clickItem.logTime == undefined || clickItem.logTime == "" ? "暂无" : clickItem.logTime }}</strong></p>
          <p><strong>直播倒计时 : {{ Countdown }}</strong></p>
        </b-col>
      </b-row>
    </b-modal>

    <!-- 大华/乐橙 m3u8直播弹窗（替换video-player为原生video.js） -->
    <b-modal no-close-on-backdrop no-close-on-esc scrollable id="modal-img" size="xl" hide-footer title="直播" ref="modal" @hidden="destroyVideoPlayer">
      <b-row>
        <b-col>
          <!-- video.js标准DOM，必须带video-js类名 -->
          <video ref="videoDom" class="video-js vjs-big-play-centered" style="width:100%;height:625px;"></video>
        </b-col>
        <b-col cols="4">
          <p><strong>观测地点 : {{ clickItem.lineName || "" }} {{ clickItem.stationName || "" }}</strong></p>
          <p><strong>电话卡号 : {{ clickItem.phoneId || "暂无" }}</strong></p>
          <p><strong>里程( k ) : {{ clickItem.distance || "暂无" }}</strong></p>
          <p><strong>当前接收时间 : {{ clickItem.logTime == undefined || clickItem.logTime == "" ? "暂无" : clickItem.logTime }}</strong></p>
          <p><strong>直播倒计时 : {{ Countdown }}</strong></p>
          <p><strong>云台控制：</strong></p>
          <div class="ptz">
            <div class="outer-ring">
              <b-icon icon="caret-up-fill" class="caret-up" @click="ptzController(clickItem, 0)"></b-icon>
              <b-icon icon="caret-down-fill" class="caret-down" @click="ptzController(clickItem, 1)"></b-icon>
              <b-icon icon="caret-left-fill" class="caret-left" @click="ptzController(clickItem, 2)"></b-icon>
              <b-icon icon="caret-right-fill" class="caret-right" @click="ptzController(clickItem, 3)"></b-icon>
              <div class="inner-ring">
                <b-icon type="plus" icon="plus" class="plus" @click="ptzController(clickItem, 8)">+</b-icon>
                <div class="line"></div>
                <b-icon type="minus" icon="dash" class="minus" @click="ptzController(clickItem, 9)">-</b-icon>
              </div>
            </div>
          </div>
          <div>
            <b-form-select @change="resolutionChange" v-model="selected" :options="options" size="sm" class="mt-3"></b-form-select>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import { BIcon } from "bootstrap-vue";
// 引入标准video.js + hls官方插件
import videojs from 'video.js'
import '@videojs/http-streaming'

export default {
  name: "ImageList",
  components: {
    BIcon
    // 移除废弃videoPlayer组件
  },
  props: {
    channelNo: Number,
    deviceSerial: String,
    getJumpItem: Function
  },
  data() {
    return {
      imageObjectUrls: {},
      // 移除旧playerOptions，改用实例变量控制
      videoPlayer: null, // video.js播放器实例
      options: [
        { value: "标清", text: "标清" },
        { value: "高清", text: "高清" },
      ],
      selected: "标清",
      clickItem: {},
      sourceData: [],
      Timeout: null,
      photoInterval: "",
      playTime: "",
      Countdown: "00:00:00",
      videoUrl: "", // 高清m3u8
      hlsUrl: "",   // 标清m3u8
      gklog: "",
      YDUrl: '',
      timer: null, // 倒计时定时器
      interval: null, // 全局定时器
    };
  },
  beforeDestroy() {
    clearInterval(this.interval);
    clearInterval(this.timer);
    clearTimeout(this.Timeout);
    // 页面销毁释放播放器
    this.destroyVideoPlayer();
    this.clearImageUrls();
  },
  methods: {
    // ====================== 播放器核心方法 ======================
    // 彻底销毁播放器，释放网络/内存
    destroyVideoPlayer() {
      if (this.videoPlayer) {
        this.videoPlayer.dispose()
        this.videoPlayer = null
      }
      this.hlsUrl = ''
      this.videoUrl = ''
      this.Countdown = "00:00:00"
      clearInterval(this.timer)
      clearTimeout(this.Timeout)
    },
    // 初始化播放器加载m3u8地址
    initVideoPlayer(url) {
      const videoDom = this.$refs.videoDom
      if (!videoDom || !url) return
      // 先销毁旧实例
      this.destroyVideoPlayer()
      // 创建播放器实例
      this.videoPlayer = videojs(videoDom, {
        autoplay: true,
        muted: true, // 浏览器自动播放必须静音
        language: "zh-CN",
        controls: true,
        sources: [
          {
            src: url,
            type: "application/x-mpegURL"
          }
        ],
        notSupportedMessage: "直播流失效或不支持当前格式！"
      })
      // 播放错误监听
      this.videoPlayer.on('error', () => {
        alert('直播加载失败，请关闭弹窗重新打开！')
        this.destroyVideoPlayer()
      })
    },

    // ====================== 原有图片加载逻辑（无修改） ======================
    getImageSrc(item) {
      const key = `${item.deviceCode}_${item.lastPhoto}`;
       return this.imageObjectUrls[key] || '';
    },
    // ====================== 云台控制（完全保留） ======================
    ptzController(item, conno) {
      console.log("这里是" + item.deviceCode + "操作" + conno);
      axios.get(`${this.$apiRoot}/imou/controlMovePTZ?deviceId=${item.deviceCode}&operation=${conno}`)
        .then((res) => {
          if (res.code == "200") console.log("云台操作成功");
        });
    },

    // ====================== 倒计时 ======================
    downTiem(h, m, s) {
      let _this = this;
      let timeResidue1 = (h * 3600 + m * 60 + s * 1000);
      this.timer = setInterval(function () {
        timeResidue1 -= 1000;
        if (timeResidue1 >= 0) {
          let hh = Math.floor((timeResidue1 / 1000 / 3600) % 24);
          let mm = Math.floor((timeResidue1 / 1000 / 60) % 60);
          let ss = Math.floor((timeResidue1 / 1000) % 60);
          _this.Countdown = `${String(hh).padStart(2, '0')}:${String(mm).padStart(2, '0')}:${String(ss).padStart(2, '0')}`;
        } else {
          _this.Countdown = "00:00:00";
          clearInterval(_this.timer);
        }
      }, 1000);
    },

    // ====================== 获取乐橙/大华m3u8流 ======================
    getLiveStreamInfo(item) {
      axios.get(`${this.$apiRoot}/imou/getLiveStreamInfo?deviceId=${item.deviceCode}`)
        .then((res) => {
          if (res.data.code !== 200) {
            alert(res.data.message)
            return
          }
          // 分别缓存标清、高清地址
          res.data.data.forEach(stream => {
            if (stream.streamId == 1) {
              this.hlsUrl = stream.hls; // 标清
            } else {
              this.videoUrl = stream.hls; // 高清
            }
          });
          this.clickItem = item;
          // 清空旧定时器
          clearInterval(this.timer);
          clearTimeout(this.Timeout);
          // 开启倒计时
          this.downTiem(0, 0, Number(this.playTime));
          // 倒计时结束自动销毁播放器
          this.Timeout = setTimeout(() => {
            this.destroyVideoPlayer()
          }, Number(this.playTime) * 1000)
          // 打开弹窗，DOM渲染完成再初始化播放器
          this.$refs.modal.doShow()
          this.$nextTick(() => {
            // 默认加载标清
            this.initVideoPlayer(this.hlsUrl)
          })
        });
    },

    // 切换清晰度
    resolutionChange() {
      clearInterval(this.timer);
      this.Countdown = "00:00:00";
      if (this.selected == "标清") {
        this.initVideoPlayer(this.hlsUrl);
      } else if (this.selected == "高清") {
        this.initVideoPlayer(this.videoUrl);
      }
    },

    // 点击图片跳转直播弹窗
    async navigateToPhoto1(item) {
      this.gklog = 0;
      if (item.deviceType == '0') {
        await this.getWebSDKUrl(item)
      } else {
        await this.getLiveStreamInfo(item);
      }
    },

    // 移动设备iframe直播逻辑（不变）
    getWebSDKUrl(item) {
      axios.get(`${this.$apiRoot}/andmu/getWebSdkUrl/${item.deviceCode}`)
        .then((res) => {
          if (res.data.code == 200) {
            this.YDUrl = res.data.data.url
            this.$refs.modalYD.doShow()
            clearInterval(this.timer);
            clearTimeout(this.Timeout);
            this.downTiem(0, 0, Number(this.playTime));
            this.clickItem = item;
            this.Timeout = setTimeout(() => {
              const iframe = this.$refs.iframeYD;
              iframe.removeAttribute('allow', 'autoplay');
            }, Number(this.playTime) * 1000);
            this.Timeout = setTimeout(async () => {
              await axios.get(`${this.$apiRoot}/andmu/getWebSdkUrl/${item.deviceCode}`)
                .then((res) => {
                  this.YDUrl = res.data.data.url
                })
            }, (Number(this.playTime) + 1) * 1000);
          } else if (res.data.message == 'token已过期(11504)') {
            alert(res.data.message + ',正在重新获取token,稍后再试')
            axios.get(`${this.$apiRoot}/andmu/setAccessToken`)
              .then((res) => {
                if (res.data.code == 200) console.log('重新设置token成功')
                else console.log('重新获取失败', res.data.message)
              })
          } else {
            alert(res.data.message)
          }
        })
    },
    handleModalYDClose() {
      this.YDUrl = ''
    },

    // 列表、配置请求（全部保留）
    async fetchStatus() {
       try {
          const res =await axios.get(`${this.$apiRoot}/deviceSim/list`);
          const tempList = res.data.data;
          // this.clearImageUrls();
          for(const item  of tempList) {
            if (!item.lastPhoto) continue;
            //计算图片超时
            let timeArr = item.lastPhoto.split("/");
            let time2 = timeArr[timeArr.length - 1].split(".")[0].substring(0, 14);
            let time3 = time2.slice(0, 4) + "-" + time2.slice(4, 6) + "-" + time2.slice(6, 8);
            let h = Number(time2.slice(8, 60)) * 3600000;
            let m = Number(time2.slice(10, 12)) * 60000;
            let s = Number(time2.slice(12, 14)) * 1000;
            let createTime = new Date(time3).getTime() + h + m + s;
            let now = new Date().getTime();
            this.$set(item, "bol", now - createTime >= this.photoInterval * 3);
            //在此获取每个设备最后一张图片
            // const key = `${item.deviceCode}_${item.lastPhoto}`;
            // 等待单张图片加载完成
            // await this.loadImageWithToken(item, key);
          }
            // ✅所有图片加载完毕，再赋值渲染DOM
            this.sourceData = tempList;
            console.log("列表请求成功", this.sourceData);
         } catch (err) {
            console.error("列表请求失败", err);
         }
       },
     async loadImageWithToken(item, key) {
      try {
        const token = this.getToken();
        const imageUrl = item.lastPhoto;
        const response = await fetch(imageUrl, {
          headers: { 'token':  token }
        });
        if (!response.ok) throw new Error(`图片加载失败: ${response.status}`);
        const blob = await response.blob();
        const objectUrl = URL.createObjectURL(blob);
        this.imageObjectUrls[key] = objectUrl;
      } catch (error) {
        console.error('加载图片失败:', error);
        this.imageObjectUrls[key] = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNk+M9QDwADhgGAWjR9awAAAABJRU5ErkJggg==';
      }
    },
    getToken() {
      return localStorage.getItem('token') || sessionStorage.getItem('token');
    },
    getSetting() {
      axios.get(`${this.$apiRoot}/system/getSetting`)
        .then((response) => {
          this.photoInterval = response.data.data.photoInterval;
          this.playTime = response.data.data.playTime;
          // 先清除旧定时器，避免多定时器叠加
          if (this.interval) clearInterval(this.interval);
          this.fetchStatus();
          this.interval = setInterval(() => {
            this.fetchStatus();
          }, this.photoInterval * 1000);
        });
    },
    clearImageUrls() {
      // 遍历释放blob资源
      Object.values(this.imageObjectUrls).forEach(url => {
        if (url && url.startsWith('blob:')) {
          URL.revokeObjectURL(url);
        }
      });
      // 清空对象
      this.imageObjectUrls = {};
    }
  },
  mounted() {
    this.getSetting();
  }
}
</script>

<style lang="less" scoped>
.space {
  display: inline-block;
  margin-left: 40px;
}
.bv-example-row {
  margin: 20px 0;
  width: 100vw;
  display: block;
}
.item-container {
  margin-left: 60px;
  display: grid;
  grid-template-columns: repeat(auto-fit, 400px);
  grid-gap: 40px;
}
.col-item {
  margin: 0px 20px;
  display: inline-block !important;
  width: 350px !important;
}
.ptz {
  .outer-ring {
    position: relative;
    width: 150px;
    height: 150px;
    background-color: #fff;
    border-radius: 50%;
    box-shadow: inset 0 0 25px #e8e8e8, 0 1px 0 #c3c3c3, 0 2px 0 #c9c9c9, 0 2px 3px #333;
    i {
      font-size: 20px;
      cursor: pointer;
      &:hover {
        color: #00b176;
      }
    }
    .caret-up {
      position: absolute;
      top: 6px;
      left: 75px;
      margin-left: -10px;
    }
    .caret-down {
      position: absolute;
      bottom: 6px;
      left: 75px;
      margin-left: -10px;
    }
    .caret-left {
      position: absolute;
      left: 6px;
      top: 75px;
      margin-top: -10px;
    }
    .caret-right {
      position: absolute;
      right: 6px;
      top: 75px;
      margin-top: -10px;
    }
    .inner-ring {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 80px;
      height: 80px;
      border-radius: 50%;
      background-color: #fff;
      border: 1px solid #ddd;
      .plus {
        position: absolute;
        top: 10px;
        left: 40px;
        margin-left: -10px;
      }
      .line {
        height: 1px;
        width: 100%;
        background-color: #ddd;
        position: absolute;
        top: 39px;
        left: 0;
      }
      .minus {
        position: absolute;
        bottom: 10px;
        left: 40px;
        margin-left: -10px;
      }
    }
  }
}
</style>